import { combineEpics } from 'redux-observable'
import VideoEpic from './Video/video.epic'

const rootEpic = combineEpics(VideoEpic.videoToken, VideoEpic.logoutApi ,VideoEpic.chatHistoryApi)
export default rootEpic
